import React from "react";
import { useSelector } from "react-redux";
import { Col, Row } from "reactstrap";
import CommonButton from "../Utils/CommonButton";
import { useNavigate } from "react-router-dom";
import StatusBadge from "../Customers/StatusBadge";

const ViewDevice = () => {
  const navigate = useNavigate();
  const fetchDeviceData = useSelector((state) => state.fetchDevice.fetchDevice);
  const renderDoubleColumnRow = (
    leftLabel,
    leftValue,
    rightLabel,
    rightValue,
    noBorder = false,
    noValue = false,
    isSingleRow = false
  ) => {
    const formatValue = (label, value) => {
      return value ? value : "N/A";
    };

    return (
      <div className={`d-flex mb-3 pb-2 ${noBorder ? "" : "border-bottom"}`}>
        <div className="w-50 pe-3 ms-4">
          {leftLabel && <label className="fw-semibold">{leftLabel}</label>}
          {!noValue && (
            <p className="detail-value mb-0">
              {formatValue(leftLabel, leftValue)}
            </p>
          )}
        </div>
        {!isSingleRow && (
          <div className="w-50 ps-3">
            {rightLabel && <label className="fw-semibold">{rightLabel}</label>}
            {!noValue && (
              <p className="detail-value mb-0">
                {formatValue(rightLabel, rightValue)}
              </p>
            )}
          </div>
        )}
      </div>
    );
  };
  return (
    <div className="customer-profile-container py-2">
      <Row className="justify-content-center">
        <Col lg={10}>
          <div className="rounded-1 px-3 py-3 my-2 bg-white">
            <div className="d-flex align-items-center mb-4">
              <div>
                <h4 className="mb-2 fw-bold text-black">
                  {fetchDeviceData?.deviceId || "N/A"}
                </h4>
                <StatusBadge value={fetchDeviceData?.status} />
              </div>
              <div className="ms-auto mt-n5">
                <CommonButton
                  color={"main-color"}
                  className={
                    "btn-label rv-primary-btn rounded-1 px-1 ps-4 py-1 w-100 w-md-auto text-nowrap mt-n4"
                  }
                  icon={
                    <i className="bx bxs-edit label-icon align-middle fs-16 me-1"></i>
                  }
                  btnTxtClsName={"px-2 ps-1 ms-3 me-1"}
                  type={"submit"}
                  buttonAction={() => {
                    navigate(`/update-device/${fetchDeviceData?.deviceId}`);
                  }}
                  buttonText={"Edit"}
                />
              </div>
            </div>
            <div className="profile-details-section">
              <p className="fs-5 fw-semibold mb-3 pb-2 border-bottom">
                Device Details
              </p>
              {renderDoubleColumnRow(
                "Device ID",
                fetchDeviceData?.deviceId,
                "Device Type",
                fetchDeviceData?.deviceType
              )}
              {fetchDeviceData?.customerName &&
                renderDoubleColumnRow(
                  "Customer Name",
                  fetchDeviceData?.customerName,
                  "Customer ID",
                  fetchDeviceData?.customerId
                )}
              {fetchDeviceData?.subscriptionId &&
                renderDoubleColumnRow(
                  "Subscription ID",
                  fetchDeviceData?.subscriptionId,
                  "",
                  null,
                  false,
                  false,
                  true
                )}
              {fetchDeviceData?.attributeList?.length > 0 ? (
                <>
                  <p className="fs-5 fw-semibold mt-4 mb-3 pb-2 border-bottom">
                    Attributes
                  </p>
                  {renderDoubleColumnRow("Name", "", "Value", "", false, true)}
                  {fetchDeviceData?.attributeList?.map((attribute, index) =>
                    renderDoubleColumnRow(
                      "",
                      attribute?.name,
                      "",
                      attribute?.value,
                      true
                    )
                  )}
                </>
              ) : null}
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default ViewDevice;
